import { createFileRoute } from '@tanstack/react-router'

import { safeRedirectPath } from '@/lib/auth'

import { LoginScreen } from '@/components/auth/LoginScreen'

function Login() {
  const { redirect } = Route.useSearch()
  return <LoginScreen redirect={redirect} />
}

export const Route = createFileRoute('/login')({
  // O destino chega pela query string do guarda de rota e é normalizado já na
  // borda: o resto da tela trabalha com um caminho interno confiável.
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: safeRedirectPath(search['redirect']),
  }),
  component: Login,
})
